import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "qa-event-preview-popup h-flex h-height-100p h-flex-dir-column h-flex-space-between" }
const _hoisted_2 = {
  key: 0,
  class: "h-pos-rel h-height-100p",
  style: {"min-height":"650px","word-break":"break-all"}
}
const _hoisted_3 = { class: "h-flex h-flex-center h-flex-space-between b-add-edit__form--header" }
const _hoisted_4 = { class: "h-text-center h-mv-20" }
const _hoisted_5 = { class: "h-fw-500" }
const _hoisted_6 = {
  key: 0,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_7 = { class: "h-mb-0" }
const _hoisted_8 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_9 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_10 = {
  key: 1,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_11 = { class: "h-mb-0" }
const _hoisted_12 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 0,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_15 = { class: "h-mb-0" }
const _hoisted_16 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_17 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_18 = {
  key: 1,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_19 = { class: "h-mb-0" }
const _hoisted_20 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_21 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_22 = {
  key: 2,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_23 = { class: "h-mb-0" }
const _hoisted_24 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_25 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_26 = {
  key: 0,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_27 = { class: "h-mb-0" }
const _hoisted_28 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_29 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_30 = {
  key: 1,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_31 = { class: "h-mb-0" }
const _hoisted_32 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_33 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_34 = {
  key: 2,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_35 = { class: "h-mb-0" }
const _hoisted_36 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_37 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_38 = {
  key: 3,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_39 = { class: "h-mb-0" }
const _hoisted_40 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_41 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_42 = {
  key: 4,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_43 = { class: "h-mb-0" }
const _hoisted_44 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_45 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_46 = {
  key: 5,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_47 = { class: "h-mb-0" }
const _hoisted_48 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_49 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_50 = {
  key: 6,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_51 = { class: "h-mb-0" }
const _hoisted_52 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_53 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_54 = {
  key: 7,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_55 = { class: "h-mb-0" }
const _hoisted_56 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_57 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_58 = {
  key: 8,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_59 = { class: "h-mb-0" }
const _hoisted_60 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_61 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_62 = {
  key: 9,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_63 = { class: "h-mb-0" }
const _hoisted_64 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_65 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_66 = {
  key: 10,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_67 = { class: "h-mb-0" }
const _hoisted_68 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_69 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_70 = {
  key: 0,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_71 = { class: "h-mb-0" }
const _hoisted_72 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_73 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_74 = {
  key: 1,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_75 = { class: "h-mb-0" }
const _hoisted_76 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_77 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_78 = {
  key: 2,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_79 = { class: "h-mb-0" }
const _hoisted_80 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_81 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_82 = {
  key: 3,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_83 = { class: "h-mb-0" }
const _hoisted_84 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_85 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_86 = {
  key: 4,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_87 = { class: "h-mb-0" }
const _hoisted_88 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_89 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_90 = {
  key: 5,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_91 = { class: "h-mb-0" }
const _hoisted_92 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_93 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_94 = {
  key: 6,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_95 = { class: "h-mb-0" }
const _hoisted_96 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_97 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_98 = {
  key: 7,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_99 = { class: "h-mb-0" }
const _hoisted_100 = {
  key: 0,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_101 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_102 = { class: "h-font-12 h-opacity-0_8" }
const _hoisted_103 = {
  key: 1,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_104 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_105 = { class: "h-font-12 h-opacity-0_8" }
const _hoisted_106 = {
  key: 2,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_107 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_108 = { class: "h-font-12 h-opacity-0_8" }
const _hoisted_109 = {
  key: 8,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_110 = { class: "h-mb-0" }
const _hoisted_111 = {
  key: 0,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_112 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_113 = { class: "h-font-12 h-opacity-0_8" }
const _hoisted_114 = {
  key: 1,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_115 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_116 = { class: "h-font-12 h-opacity-0_8" }
const _hoisted_117 = {
  key: 2,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_118 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_119 = { class: "h-font-12 h-opacity-0_8" }
const _hoisted_120 = {
  key: 3,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_121 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_122 = { class: "h-font-12 h-opacity-0_8" }
const _hoisted_123 = {
  key: 0,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_124 = { class: "h-mb-0" }
const _hoisted_125 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_126 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_127 = {
  key: 1,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_128 = { class: "h-mb-0" }
const _hoisted_129 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_130 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_131 = {
  key: 0,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_132 = { class: "h-mb-0" }
const _hoisted_133 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_134 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_135 = {
  key: 1,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_136 = { class: "h-mb-0" }
const _hoisted_137 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_138 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_139 = {
  key: 0,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_140 = { class: "h-mb-0" }
const _hoisted_141 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_142 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_143 = {
  key: 1,
  class: "h-font-14 h-fw-500 h-opacity-0_5 h-text-center"
}
const _hoisted_144 = { class: "b-edit-form__preview" }
const _hoisted_145 = { class: "b-add-edit__form--header h-flex h-flex-center h-flex-space-between" }
const _hoisted_146 = { style: {"text-align":"left","width":"100%"} }
const _hoisted_147 = { key: 1 }
const _hoisted_148 = {
  key: 0,
  class: "h-text-center"
}
const _hoisted_149 = { class: "b-add-edit__form--body" }
const _hoisted_150 = { class: "h-font-18 h-fw-500 h-text-center h-m-0" }
const _hoisted_151 = {
  key: 0,
  class: "fw-input__error-text"
}
const _hoisted_152 = { class: "b-edit-form__preview--list__headers" }
const _hoisted_153 = { class: "h-mb-0" }
const _hoisted_154 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_155 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_156 = {
  key: 0,
  class: "h-font-14 h-ml-20 h-mv-0 h-fw-500"
}
const _hoisted_157 = {
  key: 1,
  class: "h-font-14 h-ml-20 h-mv-0 h-fw-500"
}
const _hoisted_158 = {
  key: 2,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_159 = { class: "h-mb-0" }
const _hoisted_160 = {
  key: 0,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_161 = ["href"]
const _hoisted_162 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_163 = ["href"]
const _hoisted_164 = {
  key: 1,
  class: "h-font-14 h-ml-20 h-mv-0 h-fw-500"
}
const _hoisted_165 = {
  key: 3,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_166 = { class: "h-mb-0" }
const _hoisted_167 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_168 = ["href"]
const _hoisted_169 = {
  key: 4,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_170 = { class: "h-mb-0" }
const _hoisted_171 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_172 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_173 = {
  key: 5,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_174 = { class: "h-mb-0" }
const _hoisted_175 = {
  key: 0,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_176 = {
  key: 0,
  class: "h-font-14 h-ml-20 h-mv-0 h-fw-500"
}
const _hoisted_177 = { key: 0 }
const _hoisted_178 = {
  key: 1,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_179 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_180 = {
  key: 2,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_181 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_182 = {
  key: 3,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_183 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_184 = {
  key: 4,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_185 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_186 = {
  key: 5,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_187 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_188 = {
  key: 6,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_189 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_190 = {
  key: 7,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_191 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_192 = {
  key: 6,
  class: "b-edit-form__preview--list__headers h-mb-40"
}
const _hoisted_193 = { class: "h-mb-0" }
const _hoisted_194 = {
  key: 0,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_195 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_196 = {
  key: 0,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_197 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_198 = {
  key: 0,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_199 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_200 = {
  key: 1,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_201 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_202 = {
  key: 2,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_203 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_204 = {
  key: 0,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_205 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_206 = {
  key: 1,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_207 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_208 = {
  key: 2,
  class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
}
const _hoisted_209 = { class: "h-font-14 h-ml-20 h-mv-0 h-fw-500" }
const _hoisted_210 = { class: "h-flex h-flex-center h-flex-space-between h-height-100p" }
const _hoisted_211 = { class: "b-add-edit__form__option h-flex h-flex-center" }
const _hoisted_212 = { class: "qa-private-event-title" }
const _hoisted_213 = {
  key: 8,
  class: "b-edit-form__preview--list__headers"
}
const _hoisted_214 = { class: "h-mb-0" }
const _hoisted_215 = { class: "h-flex h-flex-center h-flex-justify-start h-mv-10" }
const _hoisted_216 = { class: "h-font-14 h-mv-0 h-fw-500" }
const _hoisted_217 = {
  key: 2,
  class: "h-width-100p h-flex h-flex-center b-button-delete-event"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwAvatarCard = _resolveComponent("FwAvatarCard")!
  const _component_GlobalMap = _resolveComponent("GlobalMap")!
  const _component_FwLabelCard = _resolveComponent("FwLabelCard")!
  const _component_AppointmentQualification = _resolveComponent("AppointmentQualification")!
  const _component_EditAssignedMember = _resolveComponent("EditAssignedMember")!
  const _component_CheckAvailableMemberPopup = _resolveComponent("CheckAvailableMemberPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isApptDetailsShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FwIcon, {
              class: "h-pointer",
              icon: "arrow-left",
              size: "10",
              color: "#213F6B",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isApptDetailsShow = false))
            }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.TITLE.ADDITIONAL.DETAILS')), 1)
            ]),
            _createVNode(_component_FwButton, {
              color: "transparent",
              class: "h-flex h-flex-justify-end",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("close")))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FwIcon, {
                  icon: "close",
                  size: "15",
                  color: "#BEC7D4"
                })
              ]),
              _: 1
            })
          ]),
          (_ctx.extraDataExists)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.isUserIma)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.event.appointment_intervention_order)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.OI.NUMBER')), 1),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.event.appointment_intervention_order), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_intervention_iws_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.INTERVENTION.ORDER')), 1),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("a", {
                                href: _ctx.event.appointment_intervention_iws_url,
                                target: "_blank",
                                class: "h-font-14 h-mv-0 h-fw-500"
                              }, _toDisplayString(_ctx.event.appointment_intervention_iws_url), 9, _hoisted_13)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isUserMme)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.event.appointment_company_name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.$t('LABEL.COMPANY.NAME')), 1),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.event.appointment_company_name), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_firm_name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.$t('LABEL.FIRM.NAME')), 1),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.event.appointment_firm_name), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_headcount)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("h5", _hoisted_23, _toDisplayString(_ctx.$t('LABEL.HEADCOUNT')), 1),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.event.appointment_headcount), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isUserImaNissanTech)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.event.appointment_file_number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("h5", _hoisted_27, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.FILE.NUMBER')), 1),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.event.appointment_file_number), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_visit_number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("h5", _hoisted_31, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.VISIT.NUMBER')), 1),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.event.appointment_visit_number), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_site_code)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("h5", _hoisted_35, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.SITE.CODE')), 1),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.event.appointment_site_code), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_vin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("h5", _hoisted_39, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.VIN')), 1),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.event.appointment_vin), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_dtc_1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("h5", _hoisted_43, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.DTC')), 1),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.event.appointment_dtc_1), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_dtc_2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("h5", _hoisted_47, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.DTC2')), 1),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.event.appointment_dtc_2), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_free_field_1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _createElementVNode("h5", _hoisted_51, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.FREE.FIELD')), 1),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.event.appointment_free_field_1), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_free_field_2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("h5", _hoisted_55, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.FREE.FIELD2')), 1),
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.event.appointment_free_field_2), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_phone_number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("h5", _hoisted_59, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.PHONE.NUMBER')), 1),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.event.appointment_phone_number), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("h5", _hoisted_63, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.EMAIL')), 1),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.event.appointment_email), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_car_make)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createElementVNode("h5", _hoisted_67, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.CAR.MAKE')), 1),
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.event.appointment_car_make), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isUserMatmut)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (_ctx.event.client_reference)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _createElementVNode("h5", _hoisted_71, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.CLIENT.REFERENCE')), 1),
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.event.client_reference), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.client_address)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                            _createElementVNode("h5", _hoisted_75, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.CLIENT.ADDRESS')), 1),
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("p", _hoisted_77, _toDisplayString(_ctx.event.client_address), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.client_business_contact_name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                            _createElementVNode("h5", _hoisted_79, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.CLIENT.BUSINESS.CONTACT')), 1),
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.event.client_business_contact_name), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.client_business_status)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                            _createElementVNode("h5", _hoisted_83, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.CLIENT.BUSINESS.STATUS')), 1),
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("p", _hoisted_85, _toDisplayString(_ctx.event.client_business_status), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.client_business_activity)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("h5", _hoisted_87, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.CLIENT.BUSINESS.ACTIVITY')), 1),
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("p", _hoisted_89, _toDisplayString(_ctx.event.client_business_activity), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.client_branch_external_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                            _createElementVNode("h5", _hoisted_91, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.CLIENT.BRANCH.EXTERNAL')), 1),
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("p", _hoisted_93, _toDisplayString(_ctx.event.client_branch_external_id), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.client_notes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                            _createElementVNode("h5", _hoisted_95, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.CLIENT.NOTES')), 1),
                            _createElementVNode("div", _hoisted_96, [
                              _createElementVNode("p", _hoisted_97, _toDisplayString(_ctx.event.client_notes), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.advisor_branch_name ||
                         _ctx.event.advisor_hub_name || _ctx.event.advisor_full_name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                            _createElementVNode("h5", _hoisted_99, _toDisplayString(_ctx.$t('LABEL.APPOINTMENT.TAKEN.BY')), 1),
                            (_ctx.event.advisor_full_name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                  _createElementVNode("p", _hoisted_101, [
                                    _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.$t('LABEL.NAME')) + ": ", 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.event.advisor_full_name), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.event.advisor_hub_name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                  _createElementVNode("p", _hoisted_104, [
                                    _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.$t('LABEL.HUB.NAME')) + ": ", 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.event.advisor_hub_name), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.event.advisor_branch_name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                  _createElementVNode("p", _hoisted_107, [
                                    _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.$t('LABEL.BRANCH.NAME')) + ": ", 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.event.advisor_branch_name), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.manager_hub_name || _ctx.event.manager_branch_name || _ctx.event.manager_full_name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                            _createElementVNode("h5", _hoisted_110, _toDisplayString(_ctx.$t('LABEL.APPOINTMENT.BOOKED.BY')), 1),
                            (_ctx.event.manager_full_name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                  _createElementVNode("p", _hoisted_112, [
                                    _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.$t('LABEL.NAME')) + ": ", 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.event.manager_full_name), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.event.manager_hub_name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                  _createElementVNode("p", _hoisted_115, [
                                    _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.$t('LABEL.HUB.NAME')) + ": ", 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.event.manager_hub_name), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.event.manager_branch_name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                  _createElementVNode("p", _hoisted_118, [
                                    _createElementVNode("span", _hoisted_119, _toDisplayString(_ctx.$t('LABEL.BRANCH.NAME')) + ": ", 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.event.manager_branch_name), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.event.manager_code_site && _ctx.isMatmutAccount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                  _createElementVNode("p", _hoisted_121, [
                                    _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.$t('LABEL.CODE.SITE')) + ": ", 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.event.manager_code_site), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isImaMedicalAccount)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      (_ctx.event.appointment_ima_medical_transport)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                            _createElementVNode("h5", _hoisted_124, _toDisplayString(_ctx.$t('GLOBAL.MEANS_OF_TRANSPORT')), 1),
                            _createElementVNode("div", _hoisted_125, [
                              _createElementVNode("p", _hoisted_126, _toDisplayString(_ctx.event.appointment_ima_medical_transport), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_ima_medical_team)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                            _createElementVNode("h5", _hoisted_128, _toDisplayString(_ctx.$t('GLOBAL.TEAM')), 1),
                            _createElementVNode("div", _hoisted_129, [
                              _createElementVNode("p", _hoisted_130, _toDisplayString(_ctx.event.appointment_ima_medical_team), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isUserApizee)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      (_ctx.event.appointment_business_sector)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                            _createElementVNode("h5", _hoisted_132, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.BUSINESS.SECTOR')), 1),
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("p", _hoisted_134, _toDisplayString(_ctx.event.appointment_business_sector), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.event.appointment_company)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                            _createElementVNode("h5", _hoisted_136, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.COMPANY')), 1),
                            _createElementVNode("div", _hoisted_137, [
                              _createElementVNode("p", _hoisted_138, _toDisplayString(_ctx.event.appointment_company), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("template", null, [
            (_ctx.event.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                  _createElementVNode("h5", _hoisted_140, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.NOTE')), 1),
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("p", _hoisted_142, _toDisplayString(_ctx.event.description), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_143, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.NO.ADDITIONAL.DETAILS')), 1))
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_144, [
      _createElementVNode("div", _hoisted_145, [
        (_ctx.showEditButton)
          ? (_openBlock(), _createBlock(_component_FwButton, {
              key: 0,
              class: "qa-show-edit-popup-button",
              color: "transparent",
              fontSize: "12px",
              style: {"min-width":"100px","text-align":"left"},
              onClick: _ctx.editAction
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_146, _toDisplayString(_ctx.$t('EVENT.PREVIEW.EDIT')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_147)),
        _createVNode(_component_FwButton, {
          color: "transparent",
          class: "h-flex h-flex-justify-end",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit("close")))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwIcon, {
              icon: "close",
              size: "15",
              color: "#BEC7D4"
            })
          ]),
          _: 1
        })
      ]),
      (_ctx.event.origin === `from_appointment` && _ctx.accountBookedTypeClass)
        ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
            _createElementVNode("div", {
              class: _normalizeClass(["b-edit-form__account__title", _ctx.accountBookedTypeClass])
            }, _toDisplayString(_ctx.$t('EVENT.TITLE.BOOKED.BY', { account: _ctx.accountBookedType })), 3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_149, [
        _createElementVNode("h2", _hoisted_150, [
          (_ctx.isFromUnavailabilityEvent)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.unavailabilityTitle)), 1)
              ], 64))
            : (_ctx.isFromDriveEvent)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" 🚗 " + _toDisplayString(_ctx.$t('EVENT.DRIVE.TITLE')), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_ctx.event.title), 1)
                ], 64))
        ])
      ]),
      (_ctx.userPermissionOnlyAdmin && _ctx.showAvatar && _ctx.event.origin !== "from_reserved_slot" &&
                 _ctx.event.appointment_category !== `location_category_on_site` && !_ctx.isFromDriveEvent)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["h-width-100p h-mt-20", {
                 "h-pointer": _ctx.userPermissionOnlyAdmin && _ctx.isReservedSlotType && _ctx.event.appointment_category !== `location_category_on_site` && !_ctx.event.is_private
             }]),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showAvatarChangeAppointments && _ctx.showAvatarChangeAppointments(...args)))
          }, [
            _createVNode(_component_FwAvatarCard, {
              class: _normalizeClass({ "b-hide-icon": !_ctx.isReservedSlotType || _ctx.event.is_private }),
              iconName: "edit-settings",
              userKind: _ctx.$t(_ctx.advisorLabel),
              avatarCardData: _ctx.userEvent
            }, null, 8, ["class", "userKind", "avatarCardData"]),
            (_ctx.errorEventPassed)
              ? (_openBlock(), _createElementBlock("p", _hoisted_151, _toDisplayString(_ctx.$t('ERRORS.EVENT.PAST')), 1))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_152, [
        _createElementVNode("h5", _hoisted_153, _toDisplayString(_ctx.$t('EVENT.PREVIEW.WHEN')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datesWithLocale, (date) => {
          return (_openBlock(), _createElementBlock("div", {
            key: date,
            class: "h-flex h-flex-center h-flex-justify-start h-mv-10"
          }, [
            _createVNode(_component_FwIcon, {
              icon: "calendar",
              size: "19",
              color: "#213F6B"
            }),
            _createElementVNode("p", _hoisted_154, _toDisplayString(date), 1)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_155, [
          _createVNode(_component_FwIcon, {
            icon: "calendar-time",
            size: "19",
            color: "#213F6B"
          }),
          (!_ctx.event.full_day)
            ? (_openBlock(), _createElementBlock("p", _hoisted_156, _toDisplayString(this.getCurrentDateAsMinutesAMPM(new Date(_ctx.event.dt_start), false)) + " - " + _toDisplayString(this.getCurrentDateAsMinutesAMPM(new Date(_ctx.event.dt_end), false)), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_157, _toDisplayString(_ctx.$t('CALENDAR.FULL.DAY.EVENT')), 1))
        ])
      ]),
      (((_ctx.event.longitude && _ctx.event.latitude) || _ctx.event.video_conference_url || _ctx.isEventLocationUrl) && !_ctx.isFromDriveEvent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
            _createElementVNode("h5", _hoisted_159, _toDisplayString(_ctx.$t('EVENT.PREVIEW.WHERE')), 1),
            (_ctx.event.video_conference_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                  _createVNode(_component_FwIcon, {
                    icon: "link",
                    size: "19",
                    color: "#213F6B"
                  }),
                  _createElementVNode("a", {
                    class: "h-font-14 h-ml-20 h-mv-0 h-fw-500 h-text-overflow-ellipsis h-link",
                    href: _ctx.event.video_conference_url,
                    target: "_blank"
                  }, _toDisplayString(_ctx.event.video_conference_url), 9, _hoisted_161)
                ]))
              : _createCommentVNode("", true),
            ((_ctx.event.longitude && _ctx.event.latitude) || _ctx.isEventLocationUrl)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_162, [
                    _createVNode(_component_FwIcon, {
                      icon: "location-icon",
                      size: "19",
                      color: "#213F6B"
                    }),
                    (_ctx.isEventLocationUrl)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "h-font-14 h-ml-20 h-mv-0 h-fw-500 h-text-overflow-ellipsis h-link",
                          href: _ctx.event.location,
                          target: "_blank"
                        }, _toDisplayString(_ctx.event.location), 9, _hoisted_163))
                      : (_openBlock(), _createElementBlock("p", _hoisted_164, _toDisplayString(_ctx.event.location), 1))
                  ]),
                  (_ctx.event && !_ctx.isEventLocationUrl)
                    ? (_openBlock(), _createBlock(_component_GlobalMap, {
                        key: 0,
                        latitude: _ctx.event.latitude,
                        longitude: _ctx.event.longitude,
                        forceHideMap: _ctx.isFromDriveEvent
                      }, null, 8, ["latitude", "longitude", "forceHideMap"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.event.appointment_url && _ctx.userPermissionOnlyManager)
        ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
            _createElementVNode("h5", _hoisted_166, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.CONSULT.SAAS')), 1),
            _createElementVNode("div", _hoisted_167, [
              _createVNode(_component_FwIcon, {
                icon: "link",
                size: "19",
                color: "#213F6B"
              }),
              _createElementVNode("a", {
                href: _ctx.event.appointment_url,
                target: "_blank",
                class: "h-font-14 h-ml-20 h-mv-0 h-fw-500 b-edit-form__preview--list__text"
              }, _toDisplayString(_ctx.event.appointment_url), 9, _hoisted_168)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.event.appointment_category)
        ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
            _createElementVNode("h5", _hoisted_170, _toDisplayString(_ctx.$t('LABEL.APPOINTMENT.METHOD')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.methods, (method) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_171, [
                _createVNode(_component_FwIcon, {
                  icon: _ctx.methodsMapping[method].icon,
                  size: "19",
                  color: "#213F6B"
                }, null, 8, ["icon"]),
                _createElementVNode("p", _hoisted_172, _toDisplayString(_ctx.$t(_ctx.methodsMapping[method].text)), 1)
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      (_ctx.event)
        ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
            _createElementVNode("h5", _hoisted_174, _toDisplayString(_ctx.$t('EVENT.PREVIEW.MORE')), 1),
            (_ctx.event.first_reminder_minutes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                  _createVNode(_component_FwIcon, {
                    icon: "time-icon",
                    size: "19",
                    color: "#213F6B"
                  }),
                  (_ctx.firstReminderEvent)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_176, [
                        _createTextVNode(_toDisplayString(_ctx.firstReminderEvent.title) + " ", 1),
                        (_ctx.event.second_reminder_minutes)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_177, " - " + _toDisplayString(_ctx.secondReminderEvent.title), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isEventKindRoom)
              ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                  _createVNode(_component_FwIcon, {
                    icon: "icon-door",
                    size: "20",
                    color: "#213F6B"
                  }),
                  _createElementVNode("p", _hoisted_179, _toDisplayString(_ctx.event.site_name), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.event.is_private)
              ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                  _createVNode(_component_FwIcon, {
                    icon: "eye-cross-private",
                    size: "20",
                    color: "#213F6B"
                  }),
                  _createElementVNode("p", _hoisted_181, _toDisplayString(_ctx.$t('EVENT.PRIVATE.TITLE')), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.event.freq)
              ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                  _createVNode(_component_FwIcon, {
                    icon: "reccurance-icon",
                    size: "19",
                    color: "#213F6B"
                  }),
                  _createElementVNode("p", _hoisted_183, _toDisplayString(_ctx.$t('EVENT.RECURRENCE.NEVER')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.event.freq === "daily")
              ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                  _createVNode(_component_FwIcon, {
                    icon: "reccurance-icon",
                    size: "19",
                    color: "#213F6B"
                  }),
                  _createElementVNode("p", _hoisted_185, _toDisplayString(_ctx.$t('EVENT.RECURRENCE.EVERY_DAY')) + " (" + _toDisplayString(_ctx.$t('EVENT.RECURRENCE.EVERY_DAILY' )) + ") ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.event.freq === `weekly`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                  _createVNode(_component_FwIcon, {
                    icon: "reccurance-icon",
                    size: "19",
                    color: "#213F6B"
                  }),
                  _createElementVNode("p", _hoisted_187, _toDisplayString(_ctx.$t('EVENT.RECURRENCE.EVERY_WEEK')) + " (" + _toDisplayString(_ctx.$t('EVENT.RECURRENCE.EVERY_WEEKLY' )) + ") ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.event.freq === `monthly`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                  _createVNode(_component_FwIcon, {
                    icon: "reccurance-icon",
                    size: "19",
                    color: "#213F6B"
                  }),
                  _createElementVNode("p", _hoisted_189, _toDisplayString(_ctx.$t('EVENT.RECURRENCE.EVERY_MONTH')) + " (" + _toDisplayString(_ctx.$t('EVENT.RECURRENCE.EVERY_MONTHLY' )) + ") ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.event.freq === `yearly`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                  _createVNode(_component_FwIcon, {
                    icon: "reccurance-icon",
                    size: "19",
                    color: "#213F6B"
                  }),
                  _createElementVNode("p", _hoisted_191, _toDisplayString(_ctx.$t('EVENT.RECURRENCE.EVERY_YEAR')) + " (" + _toDisplayString(_ctx.$t('EVENT.RECURRENCE.EVERY_YEARLY' )) + ") ", 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.event.appointment_client_details || _ctx.event.appointment_is_professional || _ctx.event.client_full_name || _ctx.event.client_phone || _ctx.event.client_email)
        ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
            _createElementVNode("h5", _hoisted_193, _toDisplayString(_ctx.$t('EVENT.PREVIEW.WHO')), 1),
            (_ctx.event.appointment_is_professional)
              ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                  _createVNode(_component_FwIcon, {
                    icon: "suitcase-icon",
                    size: "19",
                    color: "#213F6B"
                  }),
                  _createElementVNode("p", _hoisted_195, _toDisplayString(_ctx.event.appointment_company_title), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isUserIma || _ctx.isUserImaNissanTech || _ctx.isUserApizee)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.event.appointment_client_details)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                        _createVNode(_component_FwIcon, {
                          icon: "user_shape",
                          size: "19",
                          color: "#213F6B"
                        }),
                        _createElementVNode("p", _hoisted_197, _toDisplayString(_ctx.event.appointment_client_details), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.event.client_full_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                        _createVNode(_component_FwIcon, {
                          icon: "user_shape",
                          size: "19",
                          color: "#213F6B"
                        }),
                        _createElementVNode("p", _hoisted_199, _toDisplayString(_ctx.event.client_full_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.event.client_email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                        _createVNode(_component_FwIcon, {
                          icon: "email_letter",
                          size: "19",
                          color: "#213F6B"
                        }),
                        _createElementVNode("p", _hoisted_201, _toDisplayString(_ctx.event.client_email), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.event.client_phone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                        _createVNode(_component_FwIcon, {
                          icon: "phone",
                          size: "19",
                          color: "#213F6B"
                        }),
                        _createElementVNode("p", _hoisted_203, _toDisplayString(_ctx.event.client_phone), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64)),
            (_ctx.isApgisAccount)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (_ctx.event.cf__company_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                        _createVNode(_component_FwIcon, {
                          icon: "memberships",
                          size: "19",
                          color: "#213F6B"
                        }),
                        _createElementVNode("p", _hoisted_205, _toDisplayString(_ctx.event.cf__company_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.event.cf__siren)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                        _createVNode(_component_FwIcon, {
                          icon: "organization",
                          size: "19",
                          color: "#213F6B"
                        }),
                        _createElementVNode("p", _hoisted_207, _toDisplayString(_ctx.event.cf__siren), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.event.cf__number_of_employees)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                        _createVNode(_component_FwIcon, {
                          icon: "users",
                          size: "19",
                          color: "#213F6B"
                        }),
                        _createElementVNode("p", _hoisted_209, _toDisplayString(_ctx.event.cf__number_of_employees), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isFromAppointmentEvent && (_ctx.isUserIma || _ctx.isUserImaNissanTech || _ctx.isUserMatmut || _ctx.isImaMedicalAccount || _ctx.isUserMme || _ctx.isUserApizee))
        ? (_openBlock(), _createBlock(_component_FwLabelCard, {
            key: 7,
            class: "qa-private-event-part h-pointer h-mv-20",
            onClick: _ctx.showApptDetails
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_210, [
                _createElementVNode("div", _hoisted_211, [
                  _createVNode(_component_FwIcon, {
                    class: "h-mr-20",
                    icon: "alert-info",
                    size: "23",
                    color: "#bec7d3"
                  }),
                  _createElementVNode("span", _hoisted_212, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.TITLE.ADDITIONAL.DETAILS')), 1)
                ]),
                _createVNode(_component_FwIcon, {
                  class: "",
                  icon: "arrow-right",
                  size: "12",
                  color: "#213F6B"
                })
              ])
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.event.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
            _createElementVNode("h5", _hoisted_214, _toDisplayString(_ctx.$t('PLAN.APPOINTMENT.LABEL.NOTE')), 1),
            _createElementVNode("div", _hoisted_215, [
              _createElementVNode("p", _hoisted_216, _toDisplayString(_ctx.event.description), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isQualificationSectionShow)
        ? (_openBlock(), _createBlock(_component_AppointmentQualification, {
            key: 9,
            event: _ctx.event
          }, null, 8, ["event"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.showPreview && !_ctx.isApptDetailsShow]
    ]),
    _withDirectives(_createVNode(_component_EditAssignedMember, {
      users: _ctx.usersList,
      eventUserId: _ctx.eventUserId,
      onSaveItem: _ctx.saveItem,
      onBackButton: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPreview = true))
    }, null, 8, ["users", "eventUserId", "onSaveItem"]), [
      [_vShow, !_ctx.showPreview]
    ]),
    (_ctx.isAvailableChecking)
      ? (_openBlock(), _createBlock(_component_CheckAvailableMemberPopup, {
          key: 1,
          event: _ctx.event,
          onGoToMembersList: _ctx.goToMembersList,
          onBackToPreview: _ctx.backToPreview
        }, null, 8, ["event", "onGoToMembersList", "onBackToPreview"]))
      : _createCommentVNode("", true),
    (_ctx.isCanDelete)
      ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
          _createVNode(_component_FwButton, {
            class: "h-m-20",
            size: "medium",
            color: "alert",
            borderRadiusType: "tiny-border",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit("openDeletePopup")))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('BUTTON.DELETE')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}